import Asset, { AssetYamlType } from './asset';

// Type for sys metadata
interface SysMetadata {
  createdAt: string;
  updatedAt: string;
  status: 'published' | 'draft' | 'archived';
}

// Type for ProjectYaml GraphQL type
export interface ProjectYamlType {
  id: string;
  projectId?: string;
  title?: string;
  description?: string;
  linkUrl?: string;
  linkText?: string;
  image?: string;
  imageAlt?: string;
  category?: string;
  featured?: boolean;
  order?: number;
  sys?: SysMetadata;
  imageAsset?: AssetYamlType;
}

export default class Project {
  id: string;
  projectId?: string;
  title?: string;
  description?: string;
  linkUrl?: string;
  linkText?: string;
  image?: string;
  imageAlt?: string;
  category?: string;
  featured?: boolean;
  order?: number;
  sys?: SysMetadata;
  imageAsset?: Asset;

  constructor(project: ProjectYamlType) {
    this.id = project.id;
    this.projectId = project.projectId;
    this.title = project.title;
    this.description = project.description;
    this.linkUrl = project.linkUrl;
    this.linkText = project.linkText;
    this.image = project.image;
    this.imageAlt = project.imageAlt;
    this.category = project.category;
    this.featured = project.featured;
    this.order = project.order;
    this.sys = project.sys;
    this.imageAsset = project.imageAsset ? new Asset(project.imageAsset) : undefined;
  }

  get isFeatured(): boolean {
    return this.featured || false;
  }

  get hasImage(): boolean {
    return Boolean(this.imageAsset?.imageFile);
  }

  get categoryType(): 'mobile' | 'web' | 'book' | 'other' {
    if (!this.category) return 'other';
    
    const category = this.category.toLowerCase();
    if (category.includes('mobile') || category.includes('app')) return 'mobile';
    if (category.includes('web') || category.includes('media')) return 'web';
    if (category.includes('book')) return 'book';
    return 'other';
  }

  get displayOrder(): number {
    return this.order || 999;
  }

  get createdDate(): Date | null {
    return this.sys?.createdAt ? new Date(this.sys.createdAt) : null;
  }

  get updatedDate(): Date | null {
    return this.sys?.updatedAt ? new Date(this.sys.updatedAt) : null;
  }

  get isPublished(): boolean {
    return this.sys?.status === 'published';
  }

  get shortDescription(): string {
    if (!this.description) return '';
    return this.description.length > 100 
      ? this.description.substring(0, 100) + '...' 
      : this.description;
  }
}
